import React, { useEffect } from 'react';

import { ReactComponent as AddIcon } from '@assets/svg/add.svg';

import Button from '@components/uikit/Button/Button';
import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';
import Tabs from '@components/uikit/Tabs/Tabs';

import { MODAL_NAMES } from '@constants/modalRenderers';
import { USER_STATUSES } from '@constants/userStatuses';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { useModalActions } from '@store/useModalStore';

import { selectUsersSearchValue, selectUsersStatusValue, useUsersActions } from '../../store/useUsersStore';
import style from './style.module.scss';

const UsersFilter = () => {
  const { t } = useTranslation();

  const { data: profileData } = useUserProfileQuery();

  const { setUsersSearchValue, setUsersStatusValue } = useUsersActions();
  const { setActiveModal } = useModalActions();

  const userStatusValue = selectUsersStatusValue();
  const searchValue = selectUsersSearchValue();

  const usersStatusList = [
    { value: 'all', label: t('All') },
    { value: USER_STATUSES.ACTIVE, label: t('Active') },
    { value: USER_STATUSES.INACTIVE, label: t('Inactive') },
    { value: USER_STATUSES.UNCONFIRMED, label: t('Unconfirmed') },
  ];

  useEffect(() => {
    return () => {
      setUsersSearchValue('');
    };
  }, []);

  return (
    <div className={style.filterPanel}>
      <div className={style.statusPanel}>
        <Tabs
          id="user-status-buttons"
          value={userStatusValue}
          tabsItems={usersStatusList}
          label={t('User status')}
          type={'woHelperText'}
          onChange={setUsersStatusValue}
        />
        {profileData?.userAccess?.manageUsers && (
          <Button
            type="secondary"
            text={t('Add new user')}
            leftElement={<AddIcon className={style.addIcon} />}
            onClick={() => setActiveModal({ name: MODAL_NAMES.userModal })}
          />
        )}
      </div>
      <div className={style.searchPanel}>
        <FilterSearch
          value={searchValue}
          onChange={setUsersSearchValue}
          placeholder={`${t('Search users')}...`}
          variant={'header-search'}
        />
      </div>
    </div>
  );
};

export default UsersFilter;
